import React from "react";
import "./confirmModal.scss";

const ConfirmModal = ({
  isOpen,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirmOverlay">
      <div className="confirmModal">
        <h3>{title}</h3>
        <p>{message}</p>

        <div className="confirmActions">
          <button className="cancelBtn" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirmBtn" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
